module.exports = __webpack_public_path__ + "static/img/smartstation41.09d5111a.png";